<template>
    <div>
        <h1>Create a product</h1>

        <form class="mt-4" @submit.prevent="createProduct">
            <div class="form-group">
                <label for="name">
                    <small class="text-muted">PRODUCT NAME</small>
                </label>
                <input
                    type="text"
                    class="form-control"
                    name="name"
                    placeholder="Name"
                    v-model="name"
                    required
                    autofocus
                    :disabled="loading"
                />
            </div>

            <div class="form-group">
                <label for="name">
                    <small class="text-muted">PRODUCT NUMBER</small>
                </label>
                <input
                    type="text"
                    class="form-control"
                    name="tag"
                    placeholder="Number"
                    v-model="tag"
                    required
                    autofocus
                    :disabled="loading"
                />
            </div>

            <div class="form-group">
				<label>
					<small class="text-muted">DESCRIPTION</small>
				</label>
				<quill-editor v-model="description" :disabled="loading" />
			</div>

            <div class="form-group">
				<label>
					<small class="text-muted">FEATURES</small>
				</label>
				<quill-editor v-model="features" :disabled="loading" />
			</div>

            <div class="form-group">
				<label>
					<small class="text-muted">USES</small>
				</label>
				<quill-editor v-model="uses" :disabled="loading" />
			</div>

            <div class="form-group">
                <label for="catalog_name">
                    <small class="text-muted">TYPE</small>
                </label>
                <input
                    class="form-control"
                    name="catalog_name"
                    placeholder="Type (petrol, etc.)"
                    v-model="catalog_name"
                    required
                    autofocus
                    :disabled="loading"
                />
            </div>
            <div class="form-group">
                <label for="price">
                    <small class="text-muted">PRODUCT PRICE</small>
                </label>
                <input
                    type="number"
                    class="form-control"
                    name="price"
                    placeholder="Price"
                    v-model.number="price"
                    step="0.01"
                    required
                    autofocus
                    :disabled="loading"
                />
            </div>
            
            <div class="form-group">
                <label for="width">
                    <small class="text-muted">VOLUME</small>
                </label>
                <input
                    type="text"
                    class="form-control"
                    name="unit"
                    placeholder="Product volume (ex: 325ml)"
                    v-model="unit"
                    required
                    autofocus
                    :disabled="loading"
                />
            </div>
            <div class="form-group">
                <label for="manufacturer">
                    <small class="text-muted">MANUFACTURER</small>
                </label>
                <select
                    required
                    class="form-control"
                    name="parent"
                    v-model="manufacturer"
                    :disabled="loading"
                >
                    <option value="Proficar">Profi-car</option>
                    <option value="Wynns">Wynn's</option>
                </select>
            </div>

            <div class="form-group">
                <label for="parent">
                    <small class="text-muted">CATEGORY</small>
                </label>
                <select
                    required
                    class="form-control"
                    name="parent"
                    v-model="category_id"
                    :disabled="loading"
                >
                    <option
                        v-for="category in categories"
                        :key="category.id"
                        :value="category.id"
                    >{{ category.name }}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="content">
                    <small class="text-muted">PRODUCT MAIN IMAGE</small>
                </label>
                <file-input
                    @change="setMainImage"
                    placeholder="Choose an image"
                    required
                    :disabled="loading"
                />
            </div>
            <div class="form-group">
                <label for="content">
                    <small class="text-muted">PRODUCT IMAGES (OPTIONAL)</small>
                </label>
                <div class="d-flex mb-2">
                    <file-input
                        @change="setImage"
                        placeholder="Choose an images"
                        multiple
                        :disabled="loading"
                    />
                </div>
            </div>

            <button
                type="submit"
                class="btn btn-primary ld-ext-right mt-3"
                :disabled="loading"
                :class="{running: loading}"
            >
                {{ loading ? 'Creating…' : 'Create' }}
                <div class="ld ld-ring ld-spin" />
            </button>
        </form>

        <div class="alert alert-danger mt-4" v-if="!loading && error">
            <p class="mb-0 text-center">{{ error }}</p>
        </div>
    </div>
</template>

<script>
import { getError } from "../../../helpers";
import FileInput from "../../FileInput";
import store from "../../../store";
import { mapState } from "vuex";

export default {
    components: {
        FileInput
    },

    data() {
        return {
            name: null,
            catalog_name: null,
            description: null,
            features: null,
            uses: null,
            tag: null,
            manufacturer: "",
            category_id: null,
            unit: null,
            price: null,
            main_image: null,
            images: [],
          
            loading: false,
            error: ""
        };
    },

    methods: {
        createProduct() {
            this.loading = true;

            this.$store
                .dispatch("products/create", {
                    name: this.name,
                    description: this.description,
                    features: this.features,
                    uses: this.uses,
                    catalog_name: this.catalog_name,
                    tag: this.tag,
                    categoryId: this.category_id,
                    unit: this.unit,
                    price: this.price,
                    main_image: this.main_image,
                    images: this.images,
                    manufacturer: this.manufacturer
                })
                .then(() => {
                    this.$router.push({ name: "products" });
                })
                .catch(e => {
                    this.error = getError(e);
                    this.loading = false;
                });
        },

        setMainImage(files) {
            this.main_image = files[0];
        },
        setImage(files) {
            for (let element of files) this.images.push(element);
        },
    },

    computed: {
        ...mapState({
            categories: state => state.categories.categories
        })
    },

    async beforeRouteEnter(to, from, next) {
        await store.dispatch("categories/fetchAll");
        next(vm => {
            if (to.query.parent) vm.parent_id = to.query.parent;
        });
    },

    meta: {
        title: "Create a product",

        meta: [
            {
                property: "og:title",
                content: "Create a product / Al-Shayah"
            }
        ]
    }
};
</script>
